import { useQuery } from '@tanstack/react-query';

import type { CampaignScheduleImportCandidatesResponse } from '~/components/Offers/Detail/OfferBuilder/DealInformation/tabs/campaignSchedules/types';

import OffersService from '~/services/OffersService';

import { offerQueryKeys } from './useGetOffer';

export function useGetCampaignScheduleImportCandidates(
  offerId: string | undefined,
  { enabled = true, selectedKeys }: { enabled?: boolean; selectedKeys?: Array<string> } = {},
) {
  // Sorted so toggling checkboxes in a different order doesn't produce a spurious cache miss/refetch.
  const selectedKeysCacheKey = selectedKeys ? [...selectedKeys].sort() : undefined;

  return useQuery({
    queryKey: [...offerQueryKeys.campaignScheduleImportCandidates(offerId), selectedKeysCacheKey],
    queryFn: async ({ signal }) => {
      if (!offerId) {
        throw new Error('offerId is required');
      }

      return (await OffersService.getCampaignScheduleImportCandidates(offerId, {
        signal,
        selectedKeys: selectedKeysCacheKey,
      })) as CampaignScheduleImportCandidatesResponse;
    },
    enabled: enabled && !!offerId,
  });
}
